export default "__VITE_ASSET__9ffabe5c__"